module.exports = __webpack_public_path__ + "img/app-academy-tutor-6.6f56a0fe.png";